module.exports = __webpack_public_path__ + "media/images/fonts/HKGroteskPro/HKGroteskPro-ThinItalic-58704e50fa3e815d71e79e686653dc10.woff";